export default function getCartListFromServerCart(userCart?: any) {
  if (!userCart?.cartDetails?.length) {
    return [];
  }
  return userCart?.cartDetails
    ?.filter((cartDetail: any) => !cartDetail?.bonus)
    ?.flatMap((cartDetail: any) => ({
      stockId: cartDetail?.stock?.id,
      quantity: cartDetail?.quantity,
      cartDetailId: cartDetail?.id,
    }));
}
